import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as bovenLokaliteitPerDossierActions from "../../actions/bovenLokaliteitPerDossierActions";
import * as bovenLokaliteitPerInfrastructuurActions from "../../actions/bovenLokaliteitPerInfrastructuurActions";
import * as infrastructuurActions from "../../actions/infrastructuurActions";
import * as layoutActions from "../../actions/layoutActions";
import * as domainConstants from "../../constants/DomainConstants";

import AutoBindComponent from "../common/AutoBindComponent";
import BovenLokaliteitPerDossierForm from "./BovenLokaliteitPerDossierForm";
import BovenLokaliteitPerDossierPageHelper from "./BovenLokaliteitPerDossierPageHelper";
import convertToLabelValuePair from "../../util/convertToLabelValuePair.js";
import mergeDeep from "../../util/mergeDeep.js";
import unsavedDataDialogHandler from "../common/UnsavedDataDialogHandler";
import showToastr, { showToastrError } from "../../util/toastr.js";
import redirector from "../../util/redirector.js";

class BovenLokaliteitPerDossierPage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
		};

		this.pageHelper = new BovenLokaliteitPerDossierPageHelper(this);
	}

	// ------------------------------------------------------------------------
	componentWillReceiveProps(nextProps) {
		this.pageHelper.receiveProps(nextProps);
	}

	componentWillMount() {
		this.pageHelper.init();
	}

	render() {
		return (
			<BovenLokaliteitPerDossierForm
				bovenLokaliteitPerDossier={this.state.bovenLokaliteitPerDossier}
				infrastructuren={this.props.infrastructuren}
			/>
		);
	}
}

// ----------------------------------------------------------------------------
BovenLokaliteitPerDossierPage.propTypes = {
	bovenLokaliteitPerDossier: PropTypes.object,
	currentSportinfrastructurenInDeBuurtIndex: PropTypes.number

};

function mapStateToProps(state, ownProps) {
	const dossierId = ownProps.params.dossierId;
	const bovenLokaliteitPerDossier = state.bovenLokaliteitPerDossier;

	return {
		bovenLokaliteitPerDossier: bovenLokaliteitPerDossier.item,
		dossierId: dossierId,
		infrastructuren: state.infrastructuren
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		saveBovenLokaliteitPerDossier: bindActionCreators(bovenLokaliteitPerDossierActions.saveBovenLokaliteitPerDossier, dispatch),
		loadBovenLokaliteitPerDossier: bindActionCreators(bovenLokaliteitPerDossierActions.loadBovenLokaliteitPerDossier, dispatch),
		loadInfrastructurenByDossierId: bindActionCreators(infrastructuurActions.loadInfrastructurenByDossierId, dispatch),
		loadLayout: bindActionCreators(layoutActions.loadBovenLokaliteitPerDossierPageLayout, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(BovenLokaliteitPerDossierPage));
